// intercessionsApi.js
// Prayer_Intentions over figApi. Writes obey the house rules in
// docs/specs/SPIRIT_Intercessions_Spec_v2.md §2: Guide is never sent as ''
// (the key is omitted — and on an update, cleared with null so SharePoint
// blanks it rather than storing an empty string), Active is only sent when a
// caller actually sets it, and a Title over the cap is refused here before
// Graph refuses it with an opaque invalidRequest.
import { getItems, createItem, updateItem, deleteItem } from '../api/figApi';
import { TITLE_MAX, titleTooLong } from './intercessions';

export const LIST = 'Prayer_Intentions';

function checkTitle(title) {
  const t = String(title ?? '').trim();
  if (!t) throw new Error('A line needs some words.');
  if (titleTooLong(t)) throw new Error(`Lines are capped at ${TITLE_MAX} characters.`);
  return t;
}

// Build the payload figApi sends. `forUpdate` maps an empty Guide to null
// (clear the column); a create simply omits it.
export function fieldsFor({ title, kind, sortOrder, guide, active }, { forUpdate = false } = {}) {
  const f = {};
  if (title !== undefined) f.Title = checkTitle(title);
  if (kind !== undefined) f.Kind = kind;
  if (sortOrder !== undefined) f.SortOrder = Number(sortOrder);
  if (guide !== undefined) {
    const g = String(guide ?? '').trim();
    if (g) f.Guide = g;
    else if (forUpdate) f.Guide = null;
  }
  if (active !== undefined) f.Active = active === true;
  return f;
}

export async function loadIntentions(token) {
  return getItems(token, LIST);
}

export async function addRow(token, { title, kind, sortOrder, guide }) {
  return createItem(token, LIST, fieldsFor({ title, kind, sortOrder, guide, active: true }));
}

export async function patchRow(token, id, patch, opts = {}) {
  return updateItem(token, LIST, id, fieldsFor(patch, { forUpdate: true }), opts);
}

export async function removeRow(token, id, opts = {}) {
  return deleteItem(token, LIST, id, opts);
}
